import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ubication-component',
  templateUrl: './ubication-component.component.html',
  styleUrls: ['./ubication-component.component.scss']
})
export class UbicationComponentComponent implements OnInit {
  lng: number;
  lat: number;
  dir: string;
  height: string = "100vh"
  direccion_completa: string;
  @Input() eventData: any;
  constructor() { }

  ngOnInit(): void {
      this.lat = this.eventData.geolocalization.vc_yaxis;
      this.lng = this.eventData.geolocalization.vc_xaxis;
      this.dir = this.eventData.geolocalization.vc_custom_address;
  }

}
